var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopPicks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 227,
    viewBox: "0 0 227 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1111_2998)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 31,
    width: 157,
    height: 157,
    rx: 78.5,
    fill: "white",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.044 103.041L125.837 91.3682H120.206L126.574 103.041H139.044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.017 91.3682H95.3857L82.191 103.041H94.6614L101.017 91.3682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.819 103.041L117.451 91.3682H103.773L97.416 103.041H123.819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1503 105.459L110.528 139.087L124.061 105.459H97.1503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5625 105.459L106.648 135.849L94.5519 105.459H81.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.671 105.459L114.587 135.462L139.649 105.459H126.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5748 85.6622H87.6995V87.7869C87.6995 88.1074 87.8268 88.4147 88.0534 88.6413C88.28 88.8679 88.5874 88.9953 88.9078 88.9953C89.2283 88.9953 89.5357 88.8679 89.7623 88.6413C89.9889 88.4147 90.1162 88.1074 90.1162 87.7869V85.6622H92.2403C92.5607 85.6622 92.8681 85.5349 93.0947 85.3083C93.3213 85.0817 93.4486 84.7743 93.4486 84.4539C93.4486 84.1334 93.3213 83.826 93.0947 83.5994C92.8681 83.3728 92.5607 83.2455 92.2403 83.2455H90.1162V81.1215C90.1162 80.801 89.9889 80.4936 89.7623 80.267C89.5357 80.0404 89.2283 79.9131 88.9078 79.9131C88.5874 79.9131 88.28 80.0404 88.0534 80.267C87.8268 80.4936 87.6995 80.801 87.6995 81.1215V83.2455H85.5748C85.2585 83.2519 84.9574 83.382 84.736 83.6079C84.5146 83.8338 84.3905 84.1376 84.3905 84.4539C84.3905 84.7702 84.5146 85.0739 84.736 85.2998C84.9574 85.5257 85.2585 85.6559 85.5748 85.6622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.252 117.41H142.128V115.286C142.127 114.966 142 114.659 141.773 114.434C141.547 114.208 141.24 114.081 140.92 114.081C140.6 114.081 140.293 114.208 140.067 114.434C139.84 114.659 139.713 114.966 139.712 115.286V117.41H137.586C137.427 117.41 137.27 117.441 137.123 117.501C136.976 117.562 136.842 117.651 136.73 117.763C136.617 117.875 136.528 118.009 136.467 118.155C136.406 118.302 136.374 118.46 136.374 118.619C136.374 118.778 136.406 118.935 136.467 119.082C136.528 119.229 136.617 119.362 136.73 119.475C136.842 119.587 136.976 119.676 137.123 119.736C137.27 119.797 137.427 119.828 137.586 119.827H139.712V121.951C139.711 122.11 139.742 122.268 139.803 122.415C139.863 122.562 139.952 122.695 140.064 122.808C140.176 122.921 140.31 123.01 140.457 123.071C140.604 123.132 140.761 123.163 140.92 123.163C141.079 123.163 141.236 123.132 141.383 123.071C141.53 123.01 141.663 122.921 141.776 122.808C141.888 122.695 141.977 122.562 142.037 122.415C142.098 122.268 142.129 122.11 142.128 121.951V119.827H144.252C144.569 119.821 144.87 119.691 145.092 119.465C145.313 119.239 145.437 118.935 145.437 118.619C145.437 118.302 145.313 117.999 145.092 117.773C144.87 117.547 144.569 117.417 144.252 117.41Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1111_2998",
    x: 0.700001,
    y: 0.700001,
    width: 225.6,
    height: 225.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1111_2998"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1111_2998",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPicks);
export default __webpack_public_path__ + "static/media/topPicks.aca130b7ce931219a903e6554d5e6bc9.svg";
export { ForwardRef as ReactComponent };